import useVuelidate from '@vuelidate/core'
import { helpers, required, requiredIf } from '@vuelidate/validators'
import { UnwrapNestedRefs, computed } from 'vue'
import { useToast } from 'vue-toastification'

import useAuthUser from '@/composables/useAuthUser'

import { AvailabilityForm } from '../interfaces/availabilityForm'

const useAvailabilityValidation = (
	form: UnwrapNestedRefs<AvailabilityForm>
) => {
	const toast = useToast()
	const { user } = useAuthUser()

	const rules = computed(() => {
		return {
			member: {
				requiredIf: helpers.withMessage(
					'El socio es requerido.',
					requiredIf(() => {
						return user.value?.internal === true
					})
				),
			},
			travelers: {
				required: helpers.withMessage(
					'Por favor, seleccione al menos un viajero.',
					required
				),
			},
			destination: {
				required: helpers.withMessage(
					'Por favor, seleccione un destino.',
					required
				),
			},
			date: {
				required: helpers.withMessage(
					'Por favor, selecione un rango de fechas.',
					required
				),
			},
		}
	})

	const availabilityValidation = useVuelidate(rules, form)

	const raiseErrors = () => {
		availabilityValidation.value.$touch()
		const errors = availabilityValidation.value.$silentErrors

		console.log(errors)
		if (errors.length > 2) {
			toast.error('Por favor, corrija los errores en el formulario.')
			return
		}

		errors.forEach((error) => {
			toast.error(error.$message)
		})
	}

	return {
		availabilityValidation,
		raiseErrors,
	}
}

export default useAvailabilityValidation
